// SI, CON, Conversion
export const CONVERSION_TABLE: Record<
  string,
  [
    string[] | string,
    string[] | string,
    (x: number) => number,
    (x: number) => number,
  ]
> = {
  'body-height': ['m', 'ft/in', (x) => 39.3701 * x, (x) => x / 39.3701],
  'body-weight': ['kg', 'lb', (x) => 2.20462 * x, (x) => x / 2.20462],
  'muscle-mass': ['kg', 'lb', (x) => 2.20462 * x, (x) => x / 2.20462],
  distance: ['km', 'mi', (x) => 0.621371 * x, (x) => x / 0.621371],
  'blood-sugar': ['mmol/L', 'mg/dL', (x) => 18.016 * x, (x) => x / 18.016],
  temperature: [
    ['°C', 'C', 'Celsius'],
    ['°F', 'F', 'Fahrenheit'],
    (x) => {
      return (9 * x) / 5 + 32;
    },
    (x) => ((x - 32) * 5) / 9,
  ],
  '17-hydroxycorticosteriods': [
    'mcmol/24 hrs',
    'mg/24 hrs',
    (x) => 0.36 * x,
    (x) => x / 0.36,
  ],
  alp: ['IU/L', 'ukat/L', (x) => 0.0167 * x, (x) => x / 0.0167],
  'alpha-fetoprotein-count': ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'antidiuretic-hormone--adh': [
    'pmol/L',
    'pg/mL',
    (x) => 1.0842 * x,
    (x) => x / 1.0842,
  ],
  'atrial-natriuretic-peptide--anp': ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'b-type-natriuretic-peptide--bnp': [
    'mcg/L',
    'ng/L',
    (x) => 1000 * x,
    (x) => x / 1000,
  ],
  'base-excess-deficit': ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  basophils: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  bicarbonate: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  bun: ['mmol/L', 'mg/dL', (x) => 2.8 * x, (x) => x / 2.8],
  'c-reactive-protein': ['mg/L', 'mg/dL', (x) => 0.1 * x, (x) => x / 0.1],
  calcium: ['mmol/L', 'mg/dL', (x) => 4.0078 * x, (x) => x / 4.0078],
  'calcium-ionized': ['mmol/L', 'mg/dL', (x) => 4.0078 * x, (x) => x / 4.0078],
  'carbon-dioxide': ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  chloride: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  'cortisol--urine': [
    'nmol/day',
    'mcg/24 hr',
    (x) => 0.3625 * x,
    (x) => x / 0.3625,
  ],
  'creatinine--blood': [
    'mcmol/L',
    'mg/dL',
    (x) => 0.0113 * x,
    (x) => x / 0.0113,
  ],
  'creatinine-clearance': [
    'mL/sec',
    'mL/min',
    (x) => 0.01666666666 * x,
    (x) => x / 0.01666666666,
  ],
  'd-dimer': ['nmol/L', 'ng/mL', (x) => 180 * x, (x) => x / 180],
  digoxin: ['nmol/L', 'ng/mL', (x) => 0.7809 * x, (x) => x / 0.7809],
  eosinophils: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  'estrogen--urine': [
    'mcg/24 hr',
    'nmol/L',
    (x) => 0.2724 * x,
    (x) => x / 0.2724,
  ],
  'factor-ii': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-ix': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-v': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-vii': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-viii': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-x': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-xi': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  'factor-xii': ['UI/mL', '%', (x) => 100 * x, (x) => x / 100],
  ferritin: ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'fibrinogen--factor-1': [
    'mcmol/L',
    'mg/dL',
    (x) => 34.013605442176875 * x,
    (x) => x / 34.013605442176875,
  ],
  'folate--folic-acid': [
    'nmol/L',
    'ng/mL',
    (x) => 0.4414 * x,
    (x) => x / 0.4414,
  ],
  'gamma-glutamyl-transferase': ['IU/L', 'U/L', (x) => x, (x) => x],
  gastrin: ['ng/L', 'pg/mL', (x) => x, (x) => x],
  glucagon: ['ng/L', 'pg/mL', (x) => x, (x) => x],
  'glucose--blood': ['mmol/L', 'mg/dL', (x) => 18.016 * x, (x) => x / 18.016],
  'glucose--csf': ['mmol/L', 'mg/dL', (x) => 18.016 * x, (x) => x / 18.016],
  'glucose--postprandial': [
    'mmol/L',
    'mg/dL',
    (x) => 18.016 * x,
    (x) => x / 18.016,
  ],
  'glucose--urine--24-hr': [
    'mmol/day',
    'g/24 hr',
    (x) => 1.8016 * x,
    (x) => x / 1.8016,
  ],
  'glucose-tolerance-test-fasting--ogt': [
    'mmol/L',
    'mg/dL',
    (x) => 18 * x,
    (x) => x / 18,
  ],
  'growth-hormone': ['mcg/L', 'ng/L', (x) => 1000 * x, (x) => x / 1000],
  hdl: ['mmol/L', 'mg/dL', (x) => 38.665 * x, (x) => x / 38.665],
  hemoglobin: ['mmol/L', 'g/L', (x) => 16.10738 * x, (x) => x / 16.10738],
  'insulin-assay': ['pmol/L', 'uU/mL', (x) => 0.144 * x, (x) => x / 0.144],
  'lactic-acid--arterial': [
    'mmol/L',
    'mg/dL',
    (x) => 9.008 * x,
    (x) => x / 9.008,
  ],
  'lactic-acid--venous': [
    'mmol/L',
    'mg/dL',
    (x) => 9.008 * x,
    (x) => x / 9.008,
  ],
  ldl: ['mmol/L', 'mg/dL', (x) => 38.665 * x, (x) => x / 38.665],
  lymphocytes: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  magnesium: ['mmol/L', 'mEq/L', (x) => 2 * x, (x) => x / 2],
  'mean-cell-volume--mcv': ['fL', 'mm^3', (x) => x, (x) => x],
  'mean-corpuscular-hemoglobin-concentration': [
    '%',
    'g/L',
    (x) => 10 * x,
    (x) => x / 10,
  ],
  monocytes: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  'myoglobin--blood': ['nmol/L', 'ng/mL', (x) => 17.5 * x, (x) => x / 17.5],
  neutrophils: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  parathyroid: ['ng/L', 'pmol/L', (x) => x * 0.106, (x) => x * 9.43],
  'phenytoin--free': ['umol/L', 'ug/mL', (x) => 0.2523 * x, (x) => x / 0.2523],
  phosphate: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  platelets: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  potassium: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  'potassium--urine': ['mmol/day', 'mEq/24 hr', (x) => x, (x) => x],
  prealbumin: ['g/L', 'mg/dL', (x) => 100 * x, (x) => x / 100],
  pregnanediol: ['mcmol/day', 'mg/day', (x) => 0.321 * x, (x) => x / 0.321],
  prolactin: ['mcg/L', 'ng/L', (x) => 1000 * x, (x) => x / 1000],
  'prostate-specfic-antigen--psa': [
    'mcg/L',
    'ng/L',
    (x) => 1000 * x,
    (x) => x / 1000,
  ],
  protein: ['g/L', 'g/dL', (x) => 0.1 * x, (x) => x / 0.1],
  'protein-urine-24hr': [
    'mg/24 hrs',
    'g/day',
    (x) => 0.001 * x,
    (x) => x / 0.001,
  ],
  'serum-iron': ['mcmol/L', 'mcg/dL', (x) => 5.5845 * x, (x) => x / 5.5845],
  sodium: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  'testosterone-free': [
    'pmol/L',
    'ng/dL',
    (x) => 0.02884 * x,
    (x) => x / 0.02884,
  ],
  testosterone: ['nmol/L', 'ng/dL', (x) => 28.84 * x, (x) => x / 28.84],
  thyroglobulin: ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'thyroid-stimulating-hormone--tsh': ['mIU/L', 'uIU/mL', (x) => x, (x) => x],
  'thyroxine--free--t4': [
    'pmol/L',
    'ng/dL',
    (x) => 0.0777 * x,
    (x) => x / 0.0777,
  ],
  'thyroxine--total': [
    'nmol/L',
    'mcg/dL',
    (x) => 0.0777 * x,
    (x) => x / 0.0777,
  ],
  'total-bilirubin': ['mcmol/L', 'mg/dL', (x) => 0.0585 * x, (x) => x / 0.0585],
  'total-cholesterol': [
    'mmol/L',
    'mg/dL',
    (x) => 38.665 * x,
    (x) => x / 38.665,
  ],
  'total-iron-binding-capacity--tibc': [
    'mcmol/L',
    'mcg/dL',
    (x) => 5.5845 * x,
    (x) => x / 5.5845,
  ],
  'transferrin-assay': ['g/L', 'mg/dL', (x) => 100 * x, (x) => x / 100],
  triglycerides: ['mmol/L', 'mg/dL', (x) => 88.5 * x, (x) => x / 88.5],
  'triiodothyronine--free-t3': [
    'pmol/L',
    'ng/dL',
    (x) => 65097760000.0 * x,
    (x) => x / 65097760000.0,
  ],
  'troponin-i': ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'troponin-t': ['mcg/L', 'ng/mL', (x) => x, (x) => x],
  'urate--urine': [
    'mmol/day',
    'mg/24 hrs',
    (x) => 168.11 * x,
    (x) => x / 168.11,
  ],
  'urate-uric-acid--blood': [
    'mcmol/L',
    'mg/dL',
    (x) => 0.0168 * x,
    (x) => x / 0.0168,
  ],
  urobilinogen: ['mg/24 hr', 'Ehrlich units/24 hr', (x) => x, (x) => x],
  'vitamin-b12': ['pmol/L', 'pg/mL', (x) => 1.3554 * x, (x) => x / 1.3554],
  'vitamin-d': ['nmol/L', 'ng/mL', (x) => 0.4 * x, (x) => x / 0.4],
  vldl: ['mmol/L', 'mg/dL', (x) => 18 * x, (x) => x / 18],
  'von-willebrand-factor-antigen': [
    'UI/mL',
    '%',
    (x) => 100 * x,
    (x) => x / 100,
  ],
  wbc: ['10^9/L', '/mm^3', (x) => 1000 * x, (x) => x / 1000],
  'zinc--plasma': ['umol/L', 'ug/dL', (x) => 6.538 * x, (x) => x / 6.538],
  'zinc--urine': ['umol/L', 'ug/dL', (x) => 6.538 * x, (x) => x / 6.538],
  'partial-pressure-of-carbon-dioxide--pc02': [
    'kPa',
    'mmHg',
    (x) => 7.5006 * x,
    (x) => x / 7.5006,
  ],
  'partial-pressure-of-oxygen--p02': [
    'kPa',
    'mmHg',
    (x) => 7.5006 * x,
    (x) => x / 7.5006,
  ],
  anion_gap: ['mmol/L', 'mEq/L', (x) => x, (x) => x],
  albumin: ['g/L', 'g/dL', (x) => 0.1 * x, (x) => x / 0.1],
  ammonia: ['mmol/L', 'mcg/dL', (x) => 1.7031 * x, (x) => x / 1.7031],
  cortisol: ['mmol/L', 'mcg/dL', (x) => 36.25 * x, (x) => x / 36.25],
  'creatine-kinase': ['U/L', 'nmol sec/L', (x) => 0.06 * x, (x) => x / 0.06],
  'lactate-dehydrogenase--serum': [
    'U/L',
    'mol sec/L',
    (x) => 0.6 * x,
    (x) => x / 0.6,
  ],
  urobilinogen_urine_random: [
    'mcmol/L',
    'mg/dL',
    (x) => 0.0113 * x,
    (x) => x / 0.0113,
  ],
};
